import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export function LoginPage() {
  const { signIn, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
          {/* Logo / Branding */}
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-white mb-2">JigFlow</h1>
            <p className="text-blue-200 text-lg">Laser Engraving Platform</p>
          </div>

          {/* Description */}
          <div className="text-center mb-8">
            <p className="text-gray-300 text-sm">
              Create, customize, and manage your laser engraving products.
              Start with a free account — no credit card required.
            </p>
          </div>

          {/* Sign In Button */}
          <button
            onClick={signIn}
            className="w-full flex items-center justify-center gap-3 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" fill="currentColor"/>
            </svg>
            Get Started Free
          </button>

          {/* Divider */}
          <div className="mt-6 text-center">
            <p className="text-gray-400 text-xs">
              Secure authentication and billing
            </p>
          </div>

          {/* Tier Info */}
          <div className="mt-8 grid grid-cols-2 gap-3">
            <div className="bg-white/5 rounded-lg p-3 text-center">
              <div className="text-white font-semibold text-sm">Free</div>
              <div className="text-gray-400 text-xs mt-1">3 products, 5 fonts</div>
            </div>
            <div className="bg-white/5 rounded-lg p-3 text-center">
              <div className="text-white font-semibold text-sm">Starter $10/mo</div>
              <div className="text-gray-400 text-xs mt-1">20 products, 20 fonts</div>
            </div>
            <div className="bg-white/5 rounded-lg p-3 text-center">
              <div className="text-white font-semibold text-sm">Pro $20/mo</div>
              <div className="text-gray-400 text-xs mt-1">Unlimited products</div>
            </div>
            <div className="bg-white/5 rounded-lg p-3 text-center">
              <div className="text-white font-semibold text-sm">Business $30/mo</div>
              <div className="text-gray-400 text-xs mt-1">API + Desktop app</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
